import {
  Component, Input, Output, EventEmitter, ChangeDetectorRef, ViewChild,
  OnInit, OnDestroy,
} from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import * as moment from 'moment-timezone';

import { SearchWidgetComponent } from 'shared/search-widget/search-widget.component';
import { SearchModel } from 'shared/search/search.model';
import { ExportManagerSearchService } from 'shared/export-manager/export-manager-search.service';
import { BrandService } from 'shared/brand/brand.service';
import { ExportDownloadsModalComponent } from 'shared/modal/export-downloads-modal/export-downloads-modal.component';
import { isInactive } from 'shared/export-manager/export-manager-helpers';

import { columns } from './search-results-columns';
import {finalize} from 'rxjs/operators';
import { isRetina } from 'utils/media';


@Component({
  moduleId: module.id,
  selector: 'export-logs',
  templateUrl: 'export-logs.component.html',
  styleUrls: ['export-logs.component.scss']
})
export class ExportLogsComponent extends SearchWidgetComponent implements OnInit, OnDestroy {
  readonly isHighDpi = isRetina();

  searchModel = new SearchModel();
  items: Array<any> = [];
  dateFormatStr: string = 'YYYY-MM-DD';
  searchResultsColumns = columns;
  wasDataRequested: boolean = false;

  @Input() receiver: any;
  @Input() timezone: string = moment.tz.guess();

  @Output() fetchLogs = new EventEmitter<boolean>();

  @ViewChild(ExportDownloadsModalComponent, {static: false})
  downloadsModal: ExportDownloadsModalComponent | void;

  constructor(
    public brandService: BrandService,
    public searchService: ExportManagerSearchService,
    protected ref: ChangeDetectorRef,
    protected router: Router,
  ) {
    super(
      brandService,
      searchService,
    );
  }

  ngOnInit() {
    this.initSearchModel();
    this.initSubscriptions();
  }

  ngOnDestroy() {
    this.searchService.searchResults = [];
    this.searchResultsColumns = [];
    this.destroySubscriptions();
  }

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get receiverId(): string {
    return _.get(this.receiver, '_id');
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  public runSearch() {
    if (!this.receiverId) { return; }
    this.fetchLogs.emit(true);
    this.searchService.runSearch(
      this.brandService.getBrand(),
      this.searchModel,
      this.receiverId,
    )
    .pipe(finalize(() => this.fetchLogs.emit(false)))
    .subscribe(data => {
      this.wasDataRequested = true;
      this.items = data.data;
      this.ref.markForCheck();
    });
  }

  public updateLogs() {
    this._searchModel.next(this.searchModel);
  }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onViewExportClick(row: any) {
    this.router.navigate([`/export-manager/view-export/${row._id}`]);
  }

  /*******************************************
   * COMPONENT PROTECTED METHODS
   *******************************************/

   protected isCompleted(row: any): boolean {
     return _.get(row, 'status') === 2;
   }

   protected isDownloadFailed(row: any): boolean {
     return _.find(_.get(row, 'download'), 'has_error');
   }

   /*******************************************
    * COMPONENT PRIVATE METHODS
    *******************************************/

   private isInactive(row: any, name: string) {
     isInactive(row, name);
   }

   private initSearchModel() {
     this.searchModel.itemsPerPage = 5;
     this.searchResultsColumns = columns;
   }
}
